"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = void 0;
class Validator {
}
exports.Validator = Validator;
Validator.validatorFactory = (code, validator) => {
    return {
        code,
        validator,
    };
};
//# sourceMappingURL=Validator.js.map